<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">

            <h1 class="title center__text">Fullstack Lead Developer</h1>
            <div class="requirements container">
                <h3 class="requirements__title">Required Qulaifications</h3>
                <ul>
                    <li>Frontend VueJs</li>
                    <li>Frontend VueJs</li>
                    <li>Frontend VueJs</li>
                    <li>Infstracture:AWS , Docker</li>
                    <li>Infstracture:AWS , Docker</li>
                    <li>Infstracture:AWS , Docker</li>
                    <li>Infstracture:AWS , Docker</li>
                    <li>Infstracture:AWS , Docker</li>

                </ul>
                <div class="other__requirements">
                    <p> Position: Full time</p>
                    <p>location: Senegal</p>
                    <p>Compendation: to be disscussed according to profile</p>
                    <h3>How to Apply?</h3>
                    <p>to apply for this positon send an emaail to

                        <a href="mailto:recruitment@servicesms.sn">recruitment@servicesms.sn</a>
                        with the subject &OpenCurlyQuote; FullStack Developer &CloseCurlyQuote;
                    </p>

                </div>

            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.requirements {
    box-shadow: 0 67px 139px 28px rgba(0, 0, 0, .05);
    border-radius: 25px 25px 25px 0;
    
}

.requirements__title {
    padding-left: 2rem;
    padding-top: 1rem;
}

.other__requirements {
    padding-left: 1rem;
    padding-bottom: 4rem;
}

li {
    list-style-type: none;
}

li::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

@media(min-width: 65rem) {
    .requirements {
        width: 60%;
        margin: 3rem auto;
    }

    .spacer-8 {
        margin-top: 8rem;
    }
    .title{
        padding-top: 3rem;
    }
}</style>